import React from 'react';
import {
    FlexDiv,
    Heading2,
    Heading3,
    TextDefault,
    TextTiny,
    ThemedButton,
    StatusBadge,
    palette,
} from '@awarego-ui/components';

const LEVEL_COLOR = {
    Critical: palette.vibrant.raspberry,
    High: palette.vibrant.red,
    Medium: palette.vibrant.gold,
    Low: palette.evergreen.aspargus,
};

export default function AwareExposeIntro({
    mode,
    lastRun,
    error,
    loading,
    onStart,
}) {
    if (loading) {
        return (
            <FlexDiv column alignCenter justifyCenter padding={32}>
                <TextDefault color={palette.graphite.charcoal}>
                    Loading AwareExpose…
                </TextDefault>
            </FlexDiv>
        );
    }
    if (error) {
        return (
            <FlexDiv column gap={8} style={{ width: '100%' }}>
                <Heading2 displayBlock>AwareExpose</Heading2>
                <TextDefault color={palette.vibrant.red}>{error}</TextDefault>
            </FlexDiv>
        );
    }
    return (
        <div style={{ width: '100%' }}>
            <FlexDiv column gap={8}>
                <Heading2 displayBlock>AwareExpose</Heading2>
                <TextDefault color={palette.graphite.charcoal}>
                    See your personal threat profile based on what an attacker
                    could learn about you from public sources, and review three
                    educational phishing scenarios crafted from those signals.
                </TextDefault>
            </FlexDiv>

            {lastRun && (
                <FlexDiv
                    column
                    gap={8}
                    mt={24}
                    padding={20}
                    borderRadius={12}
                    backgroundColor={palette.evergreen.mintLight}
                    style={{ border: `1px solid ${palette.evergreen.mint}` }}
                >
                    <FlexDiv alignCenter gap={12}>
                        <Heading3 displayBlock>
                            Your last AwareExpose result
                        </Heading3>
                        {lastRun.exposure_level && (
                            <StatusBadge
                                text={lastRun.exposure_level}
                                color={
                                    LEVEL_COLOR[lastRun.exposure_level] ||
                                    LEVEL_COLOR.Medium
                                }
                            />
                        )}
                    </FlexDiv>
                    <TextTiny
                        color={palette.graphite.charcoal}
                        style={{ display: 'block' }}
                    >
                        Run on {new Date(lastRun.created_at).toLocaleString()}.
                        Exposure score:{' '}
                        <strong>{lastRun.exposure_score || '—'} / 100</strong>.
                        {lastRun.signals_count
                            ? ` ${lastRun.signals_count} public signals found.`
                            : ''}
                    </TextTiny>
                    {lastRun.summary && (
                        <TextDefault
                            color={palette.graphite.heavyMetal}
                            style={{ display: 'block' }}
                        >
                            {lastRun.summary}
                        </TextDefault>
                    )}
                </FlexDiv>
            )}

            {onStart && (
                <FlexDiv mt={24} gap={12}>
                    <ThemedButton
                        mode="primary"
                        text={
                            lastRun
                                ? 'Re-run AwareExpose'
                                : mode === 'authenticated'
                                  ? 'Build my threat profile'
                                  : 'Start'
                        }
                        onClick={onStart}
                    />
                </FlexDiv>
            )}
        </div>
    );
}
